import { ReactComponent as BellIcon } from 'assets/icons/icon-bell.svg';
import { ReactComponent as IconChevron } from 'assets/icons/icon-chevron.svg';
import {
  ChevronWrapper,
  CopyWrapper,
  IconWrapper,
} from 'components/alert/alert.styles';
import { H5 } from 'components/headings';
import Link from 'next/link';
import React, { FC } from 'react';
import { ReminderCardStyled } from './reminder-card.styles';

interface Props {
  date: string;
  title: string;
  href: string;
}

const ReminderCard: FC<Props> = ({ date, title, href }) => {
  return (
    <Link href={href} passHref>
      <ReminderCardStyled as='a'>
        <IconWrapper>
          <BellIcon aria-hidden />
        </IconWrapper>
        <CopyWrapper>
          <time>{date}</time>
          <H5 as='strong'>{title}</H5>
        </CopyWrapper>
        <ChevronWrapper>
          <IconChevron aria-hidden />
        </ChevronWrapper>
      </ReminderCardStyled>
    </Link>
  );
};

export default ReminderCard;
